var map = {
	"./control.svg": "70d0",
	"./dashboard.svg": "f782",
	"./device.svg": "2c87",
	"./document.svg": "fd28",
	"./dot.svg": "2631",
	"./example.svg": "30c3",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guzhang.svg": "58aa",
	"./home.svg": "6bbe",
	"./line.svg": "4b7d",
	"./link.svg": "18f0",
	"./listdot.svg": "cf6d",
	"./lock.svg": "ab00",
	"./log.svg": "fea0",
	"./menu.svg": "bd3d",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pc.svg": "f545",
	"./record.svg": "b3a3",
	"./safe.svg": "bd01",
	"./setting.svg": "05ff",
	"./size.svg": "8644",
	"./soe.svg": "6a1b",
	"./square.svg": "b0c2",
	"./statistics.svg": "a1cf",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./user2.svg": "1976"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";